module.exports = __webpack_public_path__ + "img/img89.f7a2b895.svg";